import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  // Enables the i18next backend
  .use(Backend)
  // Enable automatic language detection
  .use(LanguageDetector)
  // Enables the hook initialization module
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/translation.json`,
    },
    //Detects and caches a cookie from the language provided
    detection: {
      caches: ['localStorage', 'cookie'],
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
    },
    // Standard language used
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false,
    },
    lng: 'pt', // Fixed language
  });

export default i18n;
